export default __webpack_public_path__ + "static/Graphik-MediumItalic-Web-c369b090488ef51d8d32419db2c24a80.ttf";